import React, { useState } from 'react';
import { X, Flame } from 'lucide-react';
export function PromoBanner() {
  const [visible, setVisible] = useState(true);
  const [remaining] = useState(7);
  if (!visible) return null;
  return <div className="fixed top-16 left-0 right-0 z-40 bg-fire text-white py-2 px-4" data-id="element-213">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3" data-id="element-214">
        <Flame className="w-3 h-3 text-white/70 flex-shrink-0" data-id="element-215" />
        <p className="text-[10px] tracking-[0.15em] uppercase font-semibold text-center" data-id="element-216">
          Primeras 10 ventas — Botella de vino gratis
          <span className="ml-3 text-white/70 font-normal" data-id="element-217">
            · Solo quedan {remaining} disponibles
          </span>
        </p>
        <button onClick={() => setVisible(false)} className="absolute right-4 top-1/2 -translate-y-1/2 text-white/50 hover:text-white transition-colors" aria-label="Cerrar" data-id="element-218">
          <X className="w-3 h-3" data-id="element-219" />
        </button>
      </div>
    </div>;
}